<template>
    <fieldset>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Bas-URL</div>
            </div>
            <input
                type="url"
                class="form-control"
                required
                pattern="https://.+"
                v-model="baseUrl"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">API Key</div>
            </div>
            <input
                type="password"
                class="form-control"
                required
                v-model="apiKey"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Campaign Id</div>
            </div>
            <input
                type="number"
                class="form-control"
                required
                v-model="campaignId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Project Id</div>
            </div>
            <input
                type="number"
                class="form-control"
                required
                v-model="projectId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">ProductType Id</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="productTypeId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Banknamn</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldBankName"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Clearing</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldClearing"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Kontonummer</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldAccountNumber"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Campaign Id</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldCampaignId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Namn Id</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldNameId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: E-post</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldEmail"
                @input="onUpdate"
            />
        </div>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Address</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldAddress"
                @input="onUpdate"
            />
        </div>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Zip</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldZip"
                @input="onUpdate"
            />
        </div>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: CountryId</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldCountryId"
                @input="onUpdate"
            />
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const baseUrl = ref(null);
const apiKey = ref(null);
const campaignId = ref(null);
const projectId = ref(null);
const productTypeId = ref(null);
const fieldBankName = ref(null);
const fieldClearing = ref(null);
const fieldAccountNumber = ref(null);
const fieldNameId = ref(null);
const fieldCampaignId = ref(null);
const fieldEmail = ref(null);
const fieldAddress = ref(null);
const fieldZip = ref(null);
const fieldCountryId = ref(null);
const serializedValue = computed(() => {
  return {
    base_url: baseUrl.value,
    apiKey: apiKey.value,
    campaignId: campaignId.value,
    projectId: projectId.value,
    productTypeId: productTypeId.value,
    fieldBankName: fieldBankName.value,
    fieldClearing: fieldClearing.value,
    fieldAccountNumber: fieldAccountNumber.value,
    fieldNameId: fieldNameId.value,
    fieldCampaignId: fieldCampaignId.value,
    fieldEmail: fieldEmail.value,
    fieldAddress: fieldAddress.value,
    fieldZip: fieldZip.value,
    fieldCountryId: fieldCountryId.value
  };
});
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    baseUrl.value = modelValue.value.base_url;
    apiKey.value = modelValue.value.apiKey;
    campaignId.value = modelValue.value.campaignId;
    projectId.value = modelValue.value.projectId;
    productTypeId.value = modelValue.value.productTypeId;
    fieldBankName.value = modelValue.value.fieldBankName;
    fieldClearing.value = modelValue.value.fieldClearing;
    fieldAccountNumber.value = modelValue.value.fieldAccountNumber;
    fieldNameId.value = modelValue.value.fieldNameId;
    fieldCampaignId.value = modelValue.value.fieldCampaignId;
    fieldEmail.value = modelValue.value.fieldEmail;
    fieldAddress.value = modelValue.value.fieldAddress;
    fieldZip.value = modelValue.value.fieldZip;
    fieldCountryId.value = modelValue.value.fieldCountryId;
  }
}, {
  immediate: true
});
</script>
